export default "__VITE_ASSET__f9e76f6b__"